import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { client, errMsg } from "@/lib/api";

export default function OrganizersTab() {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ email: "", name: "" });
  const api = client("admin");
  const load = useCallback(() => client("admin").get("/admin/organizers").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/organizers", f); setF({ email: "", name: "" }); toast.success("Organizer added. They can now set their password from the sign-in page."); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (o) => { if (!window.confirm(`Remove ${o.email}?`)) return; try { await api.delete(`/admin/organizers/${o.id}`); load(); } catch (err) { toast.error(errMsg(err)); } };
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2 space-y-3">
        <h2 className="text-3xl font-bold text-amber-950">Organizers</h2>
        {list.map((o) => (
          <div key={o.id} data-testid={`organizer-row-${o.email}`} className="card-warm !p-4 flex items-center gap-3">
            <div className="flex-1 min-w-0"><p className="font-semibold text-lg">{o.name || o.email}</p><p className="text-stone-600 text-sm">{o.email} · {o.has_password ? "password set" : "hasn't signed in yet"}</p></div>
            <button data-testid={`organizer-delete-${o.email}`} onClick={() => remove(o)} className="p-2 rounded-full text-red-700 hover:bg-red-50" aria-label="Remove"><Trash2 className="w-5 h-5" /></button>
          </div>
        ))}
      </div>
      <form onSubmit={add} className="card-warm h-fit space-y-3" data-testid="add-organizer-form">
        <h3 className="text-2xl font-bold text-amber-900">Add an organizer</h3>
        <p className="text-stone-700">They'll go to the sign-in page, tap "First time here", and get an emailed code to set their own password.</p>
        <input required type="email" data-testid="organizer-email-input" className="field" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
        <input data-testid="organizer-name-input" className="field" placeholder="Name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} />
        <button data-testid="organizer-add-button" className="btn-primary w-full"><Plus className="w-5 h-5" />Add organizer</button>
      </form>
    </div>
  );
}
